import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

const TeamPage = () => (
  <Layout pageTitle="Our Team">
    <SEO title="Team" />

  </Layout>
)

export default TeamPage